var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useContext, useReducer } from "react";
import styled from "styled-components";
import { Toast } from "./";
var ToastContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  display: grid;\n  grid-template-columns: 200px;\n  grid-gap: .25em;\n"], ["\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  display: grid;\n  grid-template-columns: 200px;\n  grid-gap: .25em;\n"])));
export var toastData = {
    toasts: [],
    queue: [],
    maxNumToasts: 3,
    currId: 0,
    isToastPaused: false,
};
var ToastContext = createContext([toastData, function () { return null; }]);
ToastContext.displayName = "ToastProvider";
var ToastDispatch = createContext(function () { return null; });
ToastDispatch.displayName = "ToastDispatch";
var ToastPauser = createContext(toastData.isToastPaused);
ToastPauser.displayName = "ToastPauser";
export var useToastContext = function () {
    return useContext(ToastContext);
};
export var useToastDispatch = function () {
    return useContext(ToastDispatch);
};
export var useToastPauser = function () {
    return useContext(ToastPauser);
};
var dispatchFn = function (state, action) {
    if (Array.isArray(action)) {
        return action.reduce(function (acc, curr) { return dispatchFnSwitch(acc, curr); }, __assign({}, state));
    }
    else {
        return dispatchFnSwitch(state, action);
    }
};
var dispatchFnSwitch = function (state, action) {
    switch (action.type) {
        case "ADD_TOAST": {
            var newToast = action.payload;
            newToast.id = state.currId;
            var newState = __assign({}, state);
            if (state.toasts.length >= state.maxNumToasts) {
                var queue = Array.from(state.queue);
                queue.push(newToast);
                newState.queue = queue;
            }
            else {
                var toasts = Array.from(state.toasts);
                toasts.push(newToast);
                newState.toasts = toasts;
            }
            newState.currId++;
            return newState;
        }
        case "REMOVE_TOAST": {
            var id_1 = action.payload;
            var toasts = __spreadArray([], state.toasts, true);
            var index = toasts.findIndex(function (toast) { return toast.id === id_1; });
            if (index !== -1) {
                toasts.splice(index, 1);
            }
            var queue = __spreadArray([], state.queue, true);
            var newToasts = queue.splice(0, state.maxNumToasts - toasts.length);
            toasts = toasts.concat(newToasts);
            return __assign(__assign({}, state), { toasts: toasts, queue: queue });
        }
        case "SET_TOAST_PAUSE": {
            return __assign(__assign({}, state), { isToastPaused: action.payload });
        }
        default:
            return state;
    }
};
export var ToastProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(dispatchFn, toastData), state = _b[0], dispatch = _b[1];
    return (React.createElement(ToastDispatch.Provider, { value: dispatch },
        React.createElement(ToastPauser.Provider, { value: state.isToastPaused },
            React.createElement(ToastContext.Provider, { value: [state, dispatch] },
                children,
                React.createElement(ToastContainer, null, state.toasts.map(function (toast) { return React.createElement(Toast, __assign({ key: toast.id }, toast)); }))))));
};
var templateObject_1;
